"use client";

import { Formik } from "formik";

import ChangePasswordForm from "@/components/templates/ChangePasswordForm";
import {
  buildChangePasswordFormInitialData,
  buildChangePasswordFormSchema,
} from "@/components/templates/ChangePasswordForm/form-data";
import useAuth from "@/contexts/auth-context";
import useChangePassowrd from "@/hooks/requests/user/use-change-password";
import IUser from "@/interfaces/user.interface";
import { ProfileMessages } from "@/messages/profile/profile.messages";

type Props = {
  messages: ProfileMessages;
  user: IUser;
};
function ChangePassword({ messages, user }: Props) {
  const { changePasswordError: errorMessage, changePasswordSuccess: successMessage } = messages;
  const { logout } = useAuth();
  const { changePassword, isLoading } = useChangePassowrd();
  const onSuccess = () => logout();

  return (
    <Formik
      initialValues={buildChangePasswordFormInitialData(user)}
      validationSchema={buildChangePasswordFormSchema(messages)}
      validateOnChange={false}
      onSubmit={(formData) => changePassword({ formData, errorMessage, successMessage, onSuccess })}
    >
      {() => <ChangePasswordForm messages={messages} isLoading={isLoading} />}
    </Formik>
  );
}

export default ChangePassword;
